import courseraPlusExperiments from 'bundles/epic/clients/courseraPlus';
import { useNaptime } from 'bundles/naptimejs';
import EnterpriseSelfServeContractProductPrices from 'bundles/naptimejs/resources/enterpriseSelfServeContractProductPrices.v1';
import type { ProductPrice } from 'bundles/teams-v2/types/sharedTypes';

export const isWesOnCourseraPlusLandingPageEnabled = () =>
  courseraPlusExperiments.preview('showWesOnCourseraPlusLandingPage');

type PropsFromPriceNaptime = {
  defaultProductPrices?: Array<ProductPrice>;
};

type UseEnterpriseContractPriceOptions = {
  skipApiCall?: boolean;
};

export const useEnterpriseContractPrice = (options?: UseEnterpriseContractPriceOptions) => {
  const isExperimentEnabled = isWesOnCourseraPlusLandingPageEnabled();
  const isEnabled = isExperimentEnabled && !options?.skipApiCall;

  const {
    data: { defaultProductPrices },
  } = useNaptime<PropsFromPriceNaptime>(() => {
    if (!isEnabled) {
      return {};
    }

    return {
      defaultProductPrices: EnterpriseSelfServeContractProductPrices.getEnterpriseSelfServeContractProductPrice({
        userLimit: 1,
        billingType: 1,
        termInstallmentsTotal: 1,
      }),
    };
  }, [isEnabled]);

  const defaultProductPrice = defaultProductPrices?.[0];

  if (!defaultProductPrice) {
    return {};
  }

  return {
    enterpriseContractPrice: {
      amount: defaultProductPrice.actualLocalAmountTotal,
      currencyCode: defaultProductPrice.currencyCode,
    },
  };
};
